import { getTvObject, tv } from '@costar-ui/cosmos';

var starRatingTvObject = getTvObject({
  slots: {
    container: 'flex flex-row text-action-selected',
    star: ''
  },
  variants: {
    size: {
      sm: {
        star: 'size-[.875rem]',
        container: 'gap-[.35rem]'
      },
      md: {
        star: 'size-5',
        container: 'gap-1'
      },
      lg: {
        star: 'size-6',
        container: 'gap-1'
      }
    }
  }
});
var starRatingStyles = tv(starRatingTvObject);

export { starRatingStyles, starRatingTvObject };
//# sourceMappingURL=star-rating-styles.esm.js.map
